import { Badge, Popover, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styles from "./index.module.css";
import { CloseOutlined } from "@ant-design/icons";
import UpdateModal from "./UpdateModal";
import dayjs from "dayjs";
import * as brwr from "Store/borrower";
import { useDispatch, useSelector } from "react-redux";
import eventBus from "../../../Bus";
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'

const TodoContent = ({ setOpen, list, loading }) => {
  const dispatch = useDispatch();

  const history = useHistory();
  const [rowData, setRowData] = useState(null);

  const switchLoan = ({ loanId, borrowerId }) => {
    sessionStorage.setItem("edit", "false");
    sessionStorage.setItem("state", "{}");
    sessionStorage.setItem("originalstate", "{}");
    sessionStorage.setItem("borrowermenu", "loanSummary");
    sessionStorage.setItem(
      "borrowObj",
      JSON.stringify({ id: borrowerId, loan_id: loanId })
    );
    dispatch(brwr.ChangeBorrowerLoanId(loanId));
    dispatch(brwr.ChangeBorrowerId(borrowerId));
    track(STATSIG.LOANS.LOAN_OPEN, loanId, {
      source: 'popup',
      target_link: `/app/borrower/${loanId}`,
    })
    history.push(`/app/borrower/${loanId}`);
  };

  const handleClickItem = (item) => {
    setRowData(item);
    eventBus.emit(
      "appendPortalComponent",
      <UpdateModal
        loanId={item.loanId}
        open={true}
        onCancel={() => {
          eventBus.emit("removePortalComponent");
        }}
        // rowData={rowData}
      />
    );
    setOpen(false);
    switchLoan(item);
  };

  return (
    <div className={styles.toDoContent}>
      {loading ? (
        <div className={styles.loading}>
          <Spin />
        </div>
      ) : list.length ? (
        list.map((item, index) => (
          <div
            key={index}
            className={styles.todoItem}
            onClick={() => handleClickItem(item)}
          >
            <div className={styles.todoItemHeader}>
              <div className={styles.icon}>
                <img src="/images/calendar.svg" alt="" />
              </div>
              <div className={styles.todoItemHeader_title}>
                {item.todoTitle}
              </div>
              <span>{dayjs(item.annouceDate).format("MMM DD")}</span>
            </div>
            <div className={styles.todoItemInfo}>
              {item.todoTitle === "Disposition due" && <span>Pre-Approval letter expired. </span>}
              {item.todoDescription}
            </div>
          </div>
        ))
      ) : (
        <div className={styles.nodata}>No Data</div>
      )}
    </div>
  );
};

let inter=null;
const TodoIcon = () => {
  let configurations = JSON.parse(
    localStorage.getItem("configurations") || "{}"
  );
    
  let token = sessionStorage.getItem("ZeitroA");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [list, setList] = useState([
    // {
    //   title: "Disposition due",
    //   time: "Nov 11",
    //   address: "123 Main St, Springfield, IL",
    //   applicant: "John Doe",
    //   status: "success",
    //   days: 90,
    //   date: "2021-12-01",
    //   CurrentStage: "",
    //   CurrentStatus: "",
    //   id: "16491bc5-d600-4677-a685-5cdd5d6fb5f6",
    //   loanid: "cf679dac-15fa-4041-89d8-f1b9d33b662d",
    // },
    // {
    //   title: "Update Client Information",
    //   time: "Nov 12",
    //   address: "456 Elm St, Springfield, IL",
    //   applicant: "Jane Smith",
    //   status: "Pre-Approval letter expired.",
    //   date: "2025-11-01",
    //   loanid: "82036ba3-c697-481d-a57a-2a1c5a630081",
    //   id: "6e1c6e68-9b33-4f02-af57-aea01847b607",
    // },
  ]);

  const getList = async () => {
    try {
      setLoading(list.length?false:true);
      const response = await fetch("/los/getdispositiontodolist", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });
      if (response.status !== 200 || !response) {
        return;
      }

      const result = await response.json();
      if (result.status === "OK") {
        setList(result.data || []);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  // 每隔3分钟轮询一次，主要为展示todo条数
  useEffect(() => {
    if (configurations?.enableDispositionNotification) {
      getList();
      inter = setInterval(()=>{
        getList();
      },1*60*1000)
    }
    return () => {
      inter && clearInterval(inter);
      inter = null;
    }
  }, []);
  return configurations?.enableDispositionNotification ? (
    <Popover
      rootClassName={styles.rootPopover}
      content={<TodoContent setOpen={setOpen} loading={loading} list={list}/>}
      title={
        <div className={styles.title}>
          <span>To do</span>
          <CloseOutlined
            className={styles.closeIcon}
            onClick={() => setOpen(false)}
          />
        </div>
      }
      placement="bottomRight"
      trigger="click"
      arrow={false}
      align={{
        offset: [0, 20],
      }}
      open={open}
      onOpenChange={setOpen}
    >
      <div className={styles.toDoIcon}>
        <Badge count={list.length} overflowCount={99} color="#C21818" size="small">
          <img src="/images/todo.svg" alt="" />
        </Badge>
      </div>
    </Popover>
  ) : (
    ""
  );
};
export default TodoIcon;
